module.exports = {"id":"dp3_4l1q2","text":"Computational Thinking and Programming","instructions":"Computational thinking mainly involves breaking problems into steps that a computer can follow.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":false,"options":[{"id":"dp3_4l1q2-a1","text":"True","score":1.8},{"id":"dp3_4l1q2-a2","text":"Not sure","score":0},{"id":"dp3_4l1q2-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l1q2.json
// module id = 1176
// module chunks = 41